import { Button, Form, Popup, ScrollView, TextBox } from 'devextreme-react';
import { Label } from 'devextreme-react/bar-gauge';
import { SimpleItem } from 'devextreme-react/form';
import React, { useEffect, useRef } from 'react';
import { FormatNumber, InputOnlyNumber } from '../../common';

const CardBillWithdrawRequestPopup = ({
  onHiding,
  onValueChanged,
  onClickSave,
  withdrawInfo,
  cusEntInfo,
  visibleWithdrawPopup,
  notifyMsg,
}) => {
  // console.log('CardBillWithdrawRequestPopup Load');

  const refWithdrawAmount = useRef(null);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {
    // console.log('CardBillWithdrawRequestPopup > useEffect()');
    if (refWithdrawAmount.current) {
      setTimeout(() => {
        refWithdrawAmount.current.instance.focus();
      }, 500);
    }
  }, [visibleWithdrawPopup]);

  return (
    <React.Fragment>
      <Popup
        title="출금요청"
        fullScreen={isMobile}
        visible={visibleWithdrawPopup}
        onHiding={onHiding}
        className="popup"
        maxWidth="370px"
        maxHeight="450px"
        showCloseButton={true}
      >
        <div className="card-bill-list-withdraw-request-content popup-content">
          <Form formData={withdrawInfo} labelLocation={'left'} minColWidth={50}>
            <SimpleItem>
              <Label text="업소명" />
              <TextBox
                  width="16rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.Name}
                />
            </SimpleItem>
            <SimpleItem>
              <Label text="업체 잔액" />
              <TextBox
                  width="16rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={FormatNumber(cusEntInfo.Amount) + '원'}
              />
            </SimpleItem>
            <SimpleItem>
              <Label text="은행" />
              <TextBox
                  width="16rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.BankName}
              />
            </SimpleItem>
            <SimpleItem>
              <Label text="계좌번호" />
              <TextBox
                  width="16rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.AccountNo}
              />
            </SimpleItem>
            <SimpleItem>
              <Label text="예금주 " />
              <TextBox
                  width="16rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.BankOwnerName}
              />
            </SimpleItem>
            <SimpleItem>
              <Label text="출금금액" />
              <TextBox
                  ref={refWithdrawAmount}
                  width="16rem"
                  readOnly={false}
                  stylingMode='outlined'
                  value={FormatNumber(withdrawInfo.withdrawAmount)}
                  onValueChanged={(e) => onValueChanged('withdrawAmount', e)}
                  onInput={(e) =>
                      InputOnlyNumber(e.event, refWithdrawAmount.current)
                    }
              />
            </SimpleItem>
          </Form>
        </div>
        <div className="card-bill-list-withdraw-request-bottom">
          {/* <span className="notify-error"> notifyMsg </span> */}
          <Button
            stylingMode="contained"
            type="default"
            text="출금요청하기"
            onClick={onClickSave}
          />
        </div>
        <div className="notify">
            <span className="notify-error"> {notifyMsg} </span>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CardBillWithdrawRequestPopup);
